import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { setNewWindowUrl } from '@tencent/tencent_doc_open_url';
import { creatShortcut } from '@com/top-menu/top-menu-action';
import type { ICustomOptionsProps } from '@src/slide/application/service/export-image-manager';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { getQuery } from 'sutils';
import { isLogin } from '@src/js/common/utils';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Feature({
    adapters: [SLIDE_ADAPTER],
})
export class ExportFileFeature extends BaseTitleBarFeature {
    public constructor() {
        super();
        this.invokeExportWhenLoad();
    }


    public $onEditorOpen(): void {
        if (getQuery('convert_type') === 'image') {
            this.exportImage({
                position: getQuery('aid_position'),
            });
        }
    }

    /**
     * 导出为本地文件
     */
    public exportNative(): void {
        this.getMenuManager()?._actionNativePPT();
    }

    /**
     * 导出为 PDF
     */
    public exportPDF(needReport = true): void {
        this.getMenuManager()?.exportPDF(needReport);
    }

    /**
     * 生成本地快捷方式
     */
    public exportShortcut(): void {
        setNewWindowUrl(window, creatShortcut());
    }

    public canExportImage(): boolean {
        if (this.getAppServices().editableServiceLayer?.historyManager.isShown() || !isLogin()) {
            return true;
        }
        if (SlideDataServices.PrivilegeManager()?.exportable) {
            if (this.getSelectionService().slides?.length) {
                return false;
            }
        }
        return true;
    }

    public exportImage(options?: ICustomOptionsProps): void {
        this.getMenuManager()?.exportImage(options);
    }

    protected getCustomDisabledState(): boolean {
        return this.canExportImage();
    }

    private invokeExportWhenLoad() {
        const toolkit = getQuery('toolkit');
        const folder = getQuery('folderPath');
        const position = getQuery('aid_position');
        if (toolkit === 'ppt2pdf') {
            this.getMenuManager()?.exportPDF(true, {
                folder,
                position,
            });
        }
    }
}
